import { useQuery } from 'react-query'
import { ProblemDetails } from '../errors'
import { getCompany } from './services'
import { ApiCompany } from './types'

export const QUERYKEY_COMPANY = 'company'
export function useCompany(ico?: string) {
    return useQuery<ApiCompany, ProblemDetails>([QUERYKEY_COMPANY, ico], () => getCompany(ico), {
        retry: false,
        enabled: ico !== undefined && ico.length === 8,
    })
}
